import React from 'react';
import Logo from './assets/pga-logo.svg';

export default (function (_ref) {
  var _ref$src = _ref.src,
      src = _ref$src === undefined ? Logo : _ref$src;
  return React.createElement('img', { src: src, alt: 'PGA Logo' });
});